import MSAPIInstance from '@/services/MSAPI/MSAPIInstance.js'
import axiosInstance from '@/utils/axiosInstance.js'
import SERVICE from '@/utils/servicesUtil.js'
import MSAPIConstants from '../../services/MSAPI/MSAPIConstants'

// const USER = 'user/services/user/api/v1.0/user'

const timeZones = () => axiosInstance.get(`${SERVICE.USER}/timezones`)
const getBasicInfo = (UserId) => axiosInstance.get(`${SERVICE.USER}/${UserId}/basic-info`)
const updateBasicInfo = (UserId, userData) => axiosInstance.put(`${SERVICE.USER}/${UserId}/basic-info`, userData)

const uploadImage = (formData) => axiosInstance.post(`${SERVICE.USER}/upload-image`, formData)

const createUserInvite = (body) => axiosInstance.post(`${SERVICE.INVITE}`, body)
const getUsers = (page, count, organizationId) =>
  axiosInstance.get(`${SERVICE.ORGANIZATION}/${organizationId}/userlist?PageOptions.Page=${page}&PageOptions.Count=${count}`)
const getOrganizationUser = (organizationId, userId) => axiosInstance.get(`${SERVICE.ORGANIZATION}/${organizationId}/users/${userId}`)
const deleteUserInvite = (params) => axiosInstance.delete(`${SERVICE.INVITE}`, params)
const deleteUserFromOrganization = ($organizationId, $userId) => axiosInstance.delete(`${SERVICE.ORGANIZATION}/${$organizationId}/user/${$userId}`)
const getRolesToInvite = (organizationId) => axiosInstance.get(`${SERVICE.AUTHORIZATION}/${organizationId}/assignablerolesforinvite`)
const getInvite = ($inviteId) => axiosInstance.get(`${SERVICE.USER}/inviteregistrationinformation/${$inviteId}`)

const activeUser = (organizationId, userId) => axiosInstance.patch(`${SERVICE.ORGANIZATION}/${organizationId}/users/${userId}/enableorganizationuser`)
const inactiveUser = (organizationId, userId) =>
  axiosInstance.patch(`${SERVICE.ORGANIZATION}/${organizationId}/users/${userId}/disableorganizationuser`)

const updateInvite = ($inviteId, $data) => axiosInstance.patch(`${SERVICE.INVITE}/${$inviteId}`, $data)
const updateUserOrganizationRole = (organizationId, userId, $data) =>
  axiosInstance.patch(`${SERVICE.ORGANIZATION}/${organizationId}/users/${userId}/changerole`, $data)

const resendInvite = ($inviteId, body) => axiosInstance.post(`${SERVICE.INVITE}/${$inviteId}/resend`, body)

const logout = () => axiosInstance.post(`${SERVICE.api}/logout`)

const getApiKey = ($userId) => MSAPIInstance.get(`${MSAPIConstants.API}`, { params: $userId })
const postApiKey = ($apiKey) => MSAPIInstance.post(`${MSAPIConstants.API}`, $apiKey)

// SECURITY
const updatePassword = ($form) => axiosInstance.post(`${SERVICE.USER}/change-password`, $form)
const sendTokenToChangeEmail = (userID, body) => axiosInstance.patch(`${SERVICE.USER}/${userID}/email`, body)
const updateUserEmail = (userID, body) => axiosInstance.post(`${SERVICE.USER}/${userID}/email/confirm`, body)
const sendTokenToChangePhone = (userID, body) => axiosInstance.patch(`${SERVICE.USER}/${userID}/phone`, body)
const updateUserPhone = (userID, body) => axiosInstance.post(`${SERVICE.USER}/${userID}/phone/confirm`, body)
const disableUser = (userID) => axiosInstance.patch(`${SERVICE.USER}/${userID}/disable`)
const getMFA = (userID) => axiosInstance.get(`${SERVICE.AUTH}/mfa`, { params: { userId: userID } })
const postMFA = (params) => axiosInstance.post(`${SERVICE.AUTH}/mfa/sms`, params)
const postMFAResend = (params) => axiosInstance.post(`${SERVICE.AUTH}/mfa/sms/resend`, params)
const postMFAValidate = (params) => axiosInstance.post(`${SERVICE.AUTH}/mfa/sms/validate`, params)

const getDateFormats = () => axiosInstance.get(`${SERVICE.USER}/date-formats`)

export default {
  timeZones,
  getBasicInfo,
  updateBasicInfo,
  uploadImage,
  createUserInvite,
  getUsers,
  deleteUserInvite,
  deleteUserFromOrganization,
  getRolesToInvite,
  getInvite,
  activeUser,
  inactiveUser,
  updateInvite,
  updateUserOrganizationRole,
  getOrganizationUser,
  resendInvite,
  logout,
  getApiKey,
  postApiKey,
  updatePassword,
  sendTokenToChangeEmail,
  updateUserEmail,
  sendTokenToChangePhone,
  updateUserPhone,
  disableUser,
  getMFA,
  postMFA,
  postMFAResend,
  postMFAValidate,
  getDateFormats
}
